import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { DateTime } from 'luxon';
import { Product } from '../_cms/products/entities/Product.js';
import { ZipCity } from '../adresse.js';

@Entity()
export class FundingCreationInformation extends AdornisEntity {
  public static override _class = 'FundingCreationInformation';

  @Field(() => [String])
  public kpfIDs: Maybe<string[]>;

  @Field(() => ZipCity)
  public city: Maybe<ZipCity>;

  @Field(() => DateTime)
  public fundingBegin: Maybe<DateTime>;

  @Field(() => DateTime)
  public fundingEnd: Maybe<DateTime>;

  @Field(() => Product)
  public productToFund: Maybe<Product>;

  @Field(() => String)
  public partnerFundingID: Maybe<string>;

  /**
   * 0 insert should, 1 insert is, 2 insert both
   */
  @Field(() => Int, {
    default: v => v ?? 2,
  })
  public creationType: Maybe<number>;
}
